const briefingData = [
  {
    name: 'John Smith',
    phone: '0412345678',
    email: 'j.smith@email.com',
    company: 'PMG'
  }
]
export { briefingData }
